import { RecordType } from "./AuditTrip";

/** The two page views; they map 1:1 onto the record type of the trips they show. */
export type AuditView = RecordType;

export const AUDIT_VIEWS: readonly AuditView[] = ["digital", "analog"];
